// Utils
import { isEmptyValue } from '@/utils/Data'

export default {
  data () {
    return {
      form: {},
      validationErrors: {},
      validationErrorWatchers: {},
      errors: []
    }
  },
  computed: {
    isFormFilled () {
      return (this.requiredFields || []).every(requireField => !isEmptyValue(this.form[requireField]))
    },
    parsedFormInput () {
      return Object.entries(this.form).reduce((parsedData, [fieldName, fieldValue]) => {
        if (isEmptyValue(fieldValue) && !Array.isArray(fieldValue) && fieldValue !== undefined) {
          fieldValue = null
        }

        parsedData[fieldName] = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue

        return parsedData
      }, {})
    }
  },
  watch: {
    'error' () {
      const validationErrors = this.error?.findValidationErrors() ?? []

      this.processValidationErrors(validationErrors)
    },
    // Todo: rethinking the necessity of "errors"
    'errors' () {
      const validationErrors = this.errors?.flatMap(error => error.findValidationErrors()) ?? []

      this.processValidationErrors(validationErrors)
    }
  },
  methods: {
    isFieldRequired (field) {
      return this.requiredFields.includes(field)
    },
    removeFieldValidationError (field) {
      if (this.validationErrorWatchers[field] != null) {
        this.validationErrorWatchers[field]()
      }

      this.$delete(this.validationErrors, field)
    },
    removeRequiredField (field) {
      this.$set(this, 'requiredFields', this.requiredFields.filter((requiredField) => requiredField !== field))
    },
    getValidationErrorMessage (field) {
      return this.validationErrors[field]
    },
    getCustomFieldErrorMessage (field, error) {
      if (this.fieldErrorCustomMessages != null &&
          this.fieldErrorCustomMessages[field] != null &&
          this.fieldErrorCustomMessages[field][error] != null
      ) {
        return this.fieldErrorCustomMessages[field][error]
      }
    },
    setRequiredField (field) {
      if (!this.isFieldRequired(field)) {
        this.$set(this, 'requiredFields', [...this.requiredFields, field])
      }
    },
    setFieldValue (field, value) {
      this.$set(this.form, field, value)
    },
    setFormData (formData) {
      for (const field in formData) {
        if (this.form.hasOwnProperty(field)) {
          this.setFieldValue(field, formData[field])
        }
      }
    },
    setFieldValidationError (field, message) {
      this.$set(this.validationErrorWatchers, field, this.$watch(
        `form.${field}`,
        () => this.removeFieldValidationError(field)
      ))

      this.$set(this.validationErrors, field, message)
    },
    setValidationErrors (errors) {
      this.$set(this, 'validationErrors', errors)
    },
    setError (error) {
      this.$set(this, 'error', error)
    },
    setErrors (errors) {
      this.$set(this, 'errors', errors)
    },
    processValidationErrors (validationErrors) {
      this.setValidationErrors({})

      validationErrors.forEach(validationError => {
        const customMessage = this.getCustomFieldErrorMessage(validationError.field, validationError.error)

        this.setFieldValidationError(validationError.field, (customMessage || validationError.message))
      })
    }
  }
}
